module.exports = {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b171df2e.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }